import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {QuizFormState} from 'main/components/forms/question/state';
import {FormattedMessage} from 'react-intl';
import ActionLink from 'shared/components/links/ActionLink';
import LabelHelper from 'shared/components/LabelHelper';
import Input from 'shared/components/Input';
import {t} from 'shared/core';

const OptionItem = observer(({uiState, option, index}) => {
  const {options} = uiState;

  return (
    <div className='table pb1'>
      <div className='table-cell align-middle pr2 col-9'>
        <Input
          placeholder={t('components.question_form.OPTION_NUMBER', {index})}
          translatePlaceholder={false}
          className='small'
          value={option.value}
          onChange={e => option.value = e.target.value}
        />
      </div>
      <div className={`table-cell align-middle col-3 ${option.answer ? 'border-left--dodger pl1' : ''}`}>
        {option.answer && <FormattedMessage id='components.question_form.Correct answer'/>}
        {options.length > 1 && !option.answer && <div>
          <div className='table-cell align-middle pr1'>
            <ActionLink onClick={() => uiState.selectAsAnswer(option)}>
              <i className='material-symbols-solid h2 align-top'>{'check'}</i>
            </ActionLink>
          </div>
          <div className='table-cell align-middle'>
            <ActionLink onClick={() => uiState.removeOption(option)}>
              <i className='material-symbols-solid h2 align-top submarine'>{'close'}</i>
            </ActionLink>
          </div>
        </div>}
      </div>
    </div>
  );
});

const QuizForm = observer(({uiState}) => {
  const {options} = uiState;

  return (
    <div>
      <LabelHelper label={t('recruiting.edit.steps.Possible answers')}/>
      {options.map((option, index) =>
        <OptionItem key={index} uiState={uiState} option={option} index={index + 1}/>)}
      <ActionLink onClick={() => uiState.addOption()}>
        <FormattedMessage id='components.question_form.+ Add option'/>
      </ActionLink>
    </div>
  );
});

export default withState(QuizForm, QuizFormState);
